export const SAVE_USER_INFO = 'SAVE_USER_INFO';
export const VALIDATE_USER_PHONE = 'VALIDATE_USER_PHONE';
export const VALIDATE_USER_MAIL = 'VALIDATE_USER_MAIL';
export const SAVE_SIGN = 'SAVE_SIGN';



// WEBPACK FOOTER //
// ./src/store/open/mutation-types.js